<template>
  <div class="workoutBasicForm">
    <div class="workoutMetaStrip workoutMetaStrip--nameLoop workoutMetaStrip--hasFootTip">
      <el-form-item :label="L.displayName" required>
        <el-input v-model="local.display_name" />
      </el-form-item>
      <el-form-item :label="L.loopable" required class="workoutFormItem--loop">
        <workout-bool-choice
          v-model="local.loopable"
          false-label="false"
          true-label="true"
          :aria-label="L.loopable"
        />
      </el-form-item>
      <p class="workoutMetaStrip__footTip">{{ fieldTips.loopable }}</p>
    </div>
  </div>
</template>

<script>
import basicFormMixin from './basicFormMixin'
import WorkoutBoolChoice from './WorkoutBoolChoice.vue'
import { WORKOUT_FIELD_LABELS, WORKOUT_FIELD_TIPS } from './workoutFormConstants'
import './workoutFormLayout.css'

const EMPTY = () => ({
  display_name: '',
  loopable: false,
})

export default {
  name: 'WorkoutMusicBasicForm',
  components: { WorkoutBoolChoice },
  mixins: [basicFormMixin],
  data() {
    return {
      local: EMPTY(),
      L: WORKOUT_FIELD_LABELS,
      fieldTips: WORKOUT_FIELD_TIPS,
    }
  },
  methods: {
    buildExtaPayload() {
      return {
        display_name: this.local.display_name,
        loopable: this.local.loopable,
      }
    },
    loadFromExta(exta) {
      const data = exta || {}
      this.local = {
        display_name: data.display_name || '',
        loopable: data.loopable,
      }
      if (typeof this.local.loopable !== 'boolean') {
        this.local.loopable = Boolean(this.local.loopable)
      }
    },
    reset() {
      this.local = EMPTY()
    },
    validate() {
      if (!String(this.local.display_name || '').trim()) {
        return Promise.reject(`请填写 ${WORKOUT_FIELD_LABELS.displayName}`)
      }
      if (typeof this.local.loopable !== 'boolean') {
        return Promise.reject(`请选择 ${WORKOUT_FIELD_LABELS.loopable}`)
      }
      return Promise.resolve()
    },
    captureSnapshot() {
      return { ...this.local }
    },
  },
}
</script>
